import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthUserService } from '@src/app/modules/auth';

import { CitySwitcherItemType } from '../types';

@Injectable({
  providedIn: 'root',
})
export class CitySwitcherService {
  private readonly authUserService = inject(AuthUserService);

  readonly currentCity$ = new BehaviorSubject<CitySwitcherItemType>(null);

  constructor() {
    this.authUserService.authUser$.subscribe(authUser => {
      if (this.currentCity$.value?.cityId === authUser?.city?.cityId) return;

      if (authUser?.city) {
        this.setCurrentCity(authUser?.city);
      }
    });
  }

  setCurrentCity(city: CitySwitcherItemType) {
    this.currentCity$.next(city);
  }
}
